export default "__VITE_ASSET__DT1xXg1t__"